import gql from 'graphql-tag'

export const GET_USER_LIST = gql`
  query GetUsers {
    users {
      id
      username: name
      email
      role
      status
      avatar
    }
  }
`

export const GET_USER_BY_ID = gql`
  query GetUserById($id: Int!) {
    user(id: $id) {
      id
      username: name
      email
      role
      status
      avatar
    }
  }
`

export const GET_ROLES = gql`
  query GetRoles($name: String!) {
    roles: __type(name: $name) {
      enumValues {
        name
      }
      name
    }
  }
`
